import { ErrorMessage, Field } from "formik";

const LOCALITY_OPTIONS = [
  "Greater Mumbai (BMC)",
  "Navi Mumbai (NMMC)",
  "Thane (TMC)",
  "Kalyan-Dombivli (KDMC)",
  "Mira-Bhayandar (MBMC)",
  "Vasai-Virar (VVCMC)",
  "Ulhasnagar (UMC)",
  "Bhiwandi-Nizampur (BNMC)",
  "Panvel (PMC)",
];

const CommonInputs = ({disabledFields, hiddenFields, localityDropdown}) => {
  const isHidden = (field) => hiddenFields && hiddenFields.includes(field);
  return (
    <>
      <div class="form-group">
        <label className="required">Full Name</label>
        <Field
          className="form-control"
          type="text"
          name="name"
          placeholder="Enter Your Full Name"
        />
        <ErrorMessage name="name" component="div" className="text-danger" />
      </div>
      <div class="form-group">
        <label className="required">Email ID</label>
        <Field
          type="text"
          name="email"
          className="form-control"
          placeholder="Enter Your Email ID"
        />
        <ErrorMessage name="email" component="div" className="text-danger" />
      </div>
      <div class="form-group">
        <label className="required">Contact Number</label>
        <Field
          type="text"
          name="contact"
          className="form-control"
          placeholder="Enter Your Contact Number"
        />
        <ErrorMessage name="contact" component="div" className="text-danger" />
      </div>
      {!isHidden('country') && (
        <div class="form-group">
          <label className="required">Country</label>
          <Field
            name="country"
            disabled
            className="form-control"
            placeholder="Enter Your Country Name"
          />
          <ErrorMessage name="country" component="div" className="text-danger" />
        </div>
      )}
      <div class="form-group">
        <label className="required">State / Province / Region</label>
        <Field
          className="form-control"
          type="text"
          name="state"
          disabled={disabledFields && disabledFields.includes('state')}
          placeholder="Enter Your State / Province or Region"
        />
        <ErrorMessage name="state" component="div" className="text-danger" />
      </div>
      <div class="form-group">
        <label className="required">City</label>
        <Field
          className="form-control"
          type="text"
          name="city"
          disabled={disabledFields && disabledFields.includes('city')}
          placeholder="Enter Your City Name"
        />
        <ErrorMessage name="city" component="div" className="text-danger" />
      </div>
      {!isHidden('locality') && (
        <div class="form-group">
          <label className="required">Locality</label>
          {localityDropdown ? (
            <Field as="select" name="locality" className="form-control">
              <option value="">Select Locality</option>
              {LOCALITY_OPTIONS.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </Field>
          ) : (
            <Field
              type="text"
              name="locality"
              className="form-control"
              placeholder="Enter Your Locality"
            />
          )}
          <ErrorMessage name="locality" component="div" className="text-danger" />
        </div>
      )}
      {!isHidden('zip_code') && (
        <div class="form-group">
          <label className="required">Postal / Zip Code</label>
          <Field
            className="form-control"
            type="text"
            name="zip_code"
            placeholder="Enter Your Postal or Zip Code"
          />
          <ErrorMessage name="zip_code" component="div" className="text-danger" />
        </div>
      )}
    </>
  );
};
export default CommonInputs;
